export default [
    {
        name: "Kg. Lalang",
        lat: 3.70579195,
        lng: 101.436097,
    },
    {
        name: "Kg. Gesir",
        lat: 3.7278150499999994,
        lng: 101.42642054999999,
    }
]